export const areas = [
  {
    name: "الإسكندرية",
    areas: [
      "اسكندريه",
      "العجمي",
      "العامريه",
      "برج العرب",
    ],
  },

  {
    name: "البحيرة",
    areas: [
      "النوباريه",
      "ابو المطامير",
      "وادي النطرون",
      "مركز بدر",
      "السلمانيه",
    ],
  },

  {
    name: "مطروح",
    areas: [
      "العلمين",
      "الساحل الشمالي",
      "مارينا",
    ],
  },

  {
    name: "المنوفية",
    areas: [
      "السادات",
      "الخطاطبه",
    ],
  },

  {
    name: "الجيزة",
    areas: ["طريق الواحات"],
  },

  {
    name: "طرق ومحاور",
    areas: [
      "طريق مصر اسكندريه الصحراوي",
      "طريق وادي النطرون",
      "دائري الاقليمي",
      "طريق الضبعه",
    ],
  },
];
